import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Sidebar from "src/components/layouts/sidebar/Sidebar";
import Breadcrumb from "src/components/layouts/Common/Breadcrumb";
import AddNewGroup from "src/components/panel/groups/AddNewGroup";

const AddNewGroupView: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("add_group_title")}</title>
      </Helmet>
      <Sidebar>
        <Breadcrumb
          title={t("add_group_tab")}
          subtitle={t("add_group_subtitle")}
        />
        <AddNewGroup />
      </Sidebar>
    </>
  );
};

export default AddNewGroupView;
